<template>
    <div class="gz-input-container">
        <Label 
            :label="label" 
            :labelClickable="labelClickable" 
            :required="required"
            @labelClick="$emit('labelClick')"
        />

        <div class="gz-input__slot-container">
            <!-- Text Input -->
            <slot></slot>
            <!-- End Text Input -->
            <div class="gz-input__control-icon">
                <div v-if="loading" class="gz-loader gz-loader_sm gz-input-loader spin-cw"></div>
            </div>
        </div>
        
        <!-- Validation -->
        <ValidationMark 
            v-if="type !== 'filter'" 
            :valid="valid" 
            :validationMessage="validationMessage" 
            class="gz-input-container__validation_select"
        />
        
        <!-- Dropdown list -->
        <transition name="fade-quick" appear>
            <div class="gz-select__dropdown" v-if="loadedData">
                <div v-if="imported !== '' && !loadedData.length" class="gz-select__dropdown_noresults"><span>Ничего не найдено</span></div>
                <div 
                    v-for="(item, index) in loadedData" 
                    :key="index"
                    class="gz-select__item gz-select__item__complex"
                    @click="selectItem(item)">
                    <div class="gz-select__item__bik">{{ item.bik }}</div>
                    <div class="gz-select__item__name">{{ item.bankTitle }}</div>
                    <div class="gz-select__item__adress">{{ item.address }}</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Label from './Label'
import ValidationMark from './BaseValidationMark'

export default {
    name: 'LoadDataContainer',

    props: {
        type: {
            //Фильтр или форма
            type: String,
            default: 'form'
        },
        label: {
            type: String
        },
        labelClickable: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: true
        },
        validationMessage: {
            type: String,
            default: 'Обязательно для заполнения'
        },
        importedData: {
            //Список вариантов для выбора
            type: String
        }
    },
    components: {
        ValidationMark,
        Label
    },
    data() {
        return {
            item: '',
            loading: false,
            data: null,
            show: true
        }
    },
    computed: {
        loadedData() {
            return this.data
        },
        imported() {
            return this.importedData
        }
    },
    mounted() {
        document.addEventListener('click', () => {
            this.closeOnBlur()

            this.$emit('selectedItem', this.item) //Если не выбран из списка - очищаем значение
        })
    },
    beforeDestroy() {
        document.removeEventListener('click', () => {
            this.closeOnBlur()

            this.$emit('selectedItem', this.item) //Если не выбран из списка - очищаем значение
        })
    },
    methods: {
        closeOnBlur() {
            const target = event.target
            
            if (!target.classList.contains('gz-select__dropdown')) {
                this.data = null
            }
        },
        selectItem(item) {
            this.item = item

            this.$emit('selectedItem', this.item)
        },
        getDadata() {
            this.$axios({
                method: 'POST',
                baseURL: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/bank',
                headers: {
                    'Authorization': `Token 9411974b482697468ab895250787357d793147ad`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: {
                    query: this.importedData
                }
            }, this.loading = true)
            .then(response => {
                console.log(response)               
                
                this.data = []
                
                if (response.data.suggestions.length) {
                    response.data.suggestions.forEach(item => {                                        
                        this.data.push({
                            bankTitle: item.data.name.short ? item.data.name.short.replace("\\", "") : item.data.name.payment.replace("\\", ""),
                            bik: item.data.bic,
                            address: item.data.address.value,
                            corrAccount: item.data.correspondent_account
                        })
                    })                 
                } else {
                    this.data = null
                }


                setTimeout(() => {
                    this.loading = false
                }, 500)

            })
            .catch(err => {
                console.log('Dadata error: ', err)
            })
        },
        selectItem(item) {
            this.item = item || {}

            this.$emit('selectedItem', this.item)
        }
    },
    watch: { 
        importedData: function (val) {
            //Смотрим за изменениями в поле ввода
            this.getDadata()

            if (val === '') {
                this.loading = false
            }
        }
    }
}
</script>